import { Link, useRouterState } from "@tanstack/react-router";
import { GraduationCap, LineChart, Users, Wand2, User } from "lucide-react";
import { cn } from "@/lib/utils";
import { RoleSwitcherMenu } from "@/components/RoleSwitcher";

const TABS = [
  { to: "/teacher", label: "Classi", icon: GraduationCap },
  { to: "/teaching-studio", label: "Contenuti", icon: Wand2 },
  { to: "/teacher-results", label: "Risultati", icon: LineChart },
  { to: "/teacher-hub", label: "Community docenti", icon: Users },
  { to: "/profile", label: "Profilo", icon: User },
];

/** Barra superiore in stile "registro elettronico" per l'area docente. */
export function TeacherTopBar() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <header className="sticky top-0 z-30 border-b bg-background/85 backdrop-blur">
      <div className="mx-auto flex w-full max-w-6xl items-center gap-3 px-4 py-2">
        <span className="flex items-center gap-2 text-sm font-bold">
          <GraduationCap className="h-5 w-5 text-primary" aria-hidden />
          <span className="hidden sm:inline">Lumen Docenti</span>
        </span>
        <nav aria-label="Area docente" className="min-w-0 flex-1 overflow-x-auto">
          <ul className="flex items-center gap-1">
            {TABS.map(({ to, label, icon: Icon }) => {
              const active = pathname.startsWith(to);
              return (
                <li key={to}>
                  <Link
                    to={to}
                    className={cn(
                      "flex min-h-9 items-center gap-1.5 whitespace-nowrap rounded-full px-3 text-xs font-medium transition-colors",
                      active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-muted",
                    )}
                  >
                    <Icon className="h-4 w-4" aria-hidden />
                    {label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
        <RoleSwitcherMenu />
      </div>
    </header>
  );
}
